import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

// Create a context token to indicate when to skip error handling
export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private messageService: MessageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check the request context to see if we should skip error handling
    const skipErrorHandling = request.context.get(SKIP_ERROR_INTERCEPTOR);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Skip showing toast if specified in the request context
        // Dont show for 401
        if ((error.status === 400 || error.status > 401) && !skipErrorHandling) {
          let errorMessage = 'An error occurred';

          // Try to extract a meaningful error message
          if (error.error?.message) {
            errorMessage = error.error.message;
          } else if (error.message) {
            errorMessage = error.message;
          } else if (typeof error.error === 'string') {
            errorMessage = error.error;
          }

          let severity = 'error';
          let summary = 'Error';

          if (error.status === 400) {
            summary = 'Bad Request';
          } else if (error.status === 403) {
            summary = 'Forbidden';
          } else if (error.status === 404) {
            summary = 'Not Found';
          } else if (error.status >= 500) {
            summary = 'Server Error';
          }

          // Show toast notification
          this.messageService.add({
            severity,
            summary,
            detail: errorMessage,
            life: 5000,
            closable: true,
            icon: 'ri-error-warning-fill'
          });
        }

        return throwError(() => error);
      })
    );
  }
}
